import { render } from "./PasswordResetPage.vue?vue&type=template&id=3b923102"
import script from "./PasswordResetPage.vue?vue&type=script&lang=js"
export * from "./PasswordResetPage.vue?vue&type=script&lang=js"
script.render = render

export default script